import { theme } from '@frontend/theme';
import { PayoutDetails } from '../../components/PayoutDetails';
import { PayoutsPage } from './legacy';

export const PayoutsListPanel = () => {
  return <PayoutsPage />;
};

export const PayoutDetailsPanel = ({ payoutId, locationId }: { payoutId: string; locationId: string | null }) => {
  return (
    <div css={{ margin: theme.spacing(3) }}>
      <PayoutDetails payoutId={payoutId} payoutLocationId={locationId} />
    </div>
  );
};
